// extracted by mini-css-extract-plugin
module.exports = {"KrO2":"kr_KrO2__kpo7T"};